var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.37,
    height: 11.329,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.761 4.828 8.218.578a.232.232 0 0 0-.18-.077c-.142.006-.322.106-.322.258V2.89a.138.138 0 0 1-.116.132c-4.519.692-6.422 4.073-7.099 7.583-.026.138.161.267.248.158a8.213 8.213 0 0 1 6.826-3.459.159.159 0 0 1 .135.154v2.093a.277.277 0 0 0 .467.171l4.576-4.325a.356.356 0 0 0 .113-.271.431.431 0 0 0-.109-.3Z",
    fill: "none",
    stroke: "#2d3e5c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeShare);
export default __webpack_public_path__ + "static/media/Youtube_Share.185d41c2dc826f2e672504613c4908cf.svg";
export { ForwardRef as ReactComponent };